import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  kuponGetir,
  kuponGuncelle,
  kuponKullanimlari,
  kuponOlustur,
  kuponSil,
  kuponlariListele,
  type Kupon,
  type KuponGuncelleIstegi,
  type KuponKullanimi,
  type KuponOlusturIstegi,
  type KuponSorgusu,
  type SayfalanmisKuponlar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useKuponlar(sorgu: Partial<KuponSorgusu>) {
  return useQuery<SayfalanmisKuponlar>({
    queryKey: ['kuponlar', 'liste', sorgu],
    queryFn: () => kuponlariListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useKupon(id: string | undefined) {
  return useQuery<Kupon>({
    queryKey: ['kuponlar', 'detay', id ?? ''],
    queryFn: () => kuponGetir(istemci, id as string),
    enabled: !!id,
  });
}

export function useKuponKullanimlari(id: string | undefined) {
  return useQuery<KuponKullanimi[]>({
    queryKey: ['kuponlar', 'kullanimlar', id ?? ''],
    queryFn: () => kuponKullanimlari(istemci, id as string),
    enabled: !!id,
  });
}

export function useKuponOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (g: KuponOlusturIstegi) => kuponOlustur(istemci, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kuponlar'] }),
  });
}

export function useKuponGuncelle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...g }: KuponGuncelleIstegi & { id: string }) =>
      kuponGuncelle(istemci, id, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kuponlar'] }),
  });
}

export function useKuponSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => kuponSil(istemci, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kuponlar'] }),
  });
}
